import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
} from "@material-ui/core";
import React from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import {
  COLOR_SUCCESS,
  COLOR_SUCCESS__HOVER,
  cuideoTheme,
} from "../../../../../containers/themes/defaultTheme";

const StyledExpandPrefilterDialog = styled(Dialog)`
  .MuiDialog-paper {
    max-width: 24rem;
  }
`;

const StyledContent = styled(Typography)`
  font-size: 1rem;
  text-align: center;
  color: ${cuideoTheme.palette.primary.main};
`;

const StyledNoButton = styled(Button)`
  width: 9rem;
  height: 2.5rem;
`;

const StyledYesButton = styled(Button)`
  width: 9rem;
  background-color: ${COLOR_SUCCESS};
  height: 2.5rem;

  &:hover {
    background-color: ${COLOR_SUCCESS__HOVER};
  }

  .MuiCircularProgress-root {
    color: #999;
  }
`;

interface IExpandPrefilterDialogProps {
  open: boolean;
  isExpanding: boolean;
  onAccept: () => void;
  onCancel: (e: React.MouseEvent) => void;
}

const ExpandPrefilterDialog: React.FC<IExpandPrefilterDialogProps> = (props) => {
  const { open, isExpanding, onAccept, onCancel } = props;

  const handleCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onCancel(e);
  };

  const handleConfirm = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onAccept();
  };

  return (
    <StyledExpandPrefilterDialog open={open}>
      <DialogContent>
        <StyledContent>
          <FormattedMessage
            id="ExpandPrefilterDialog.¿Quieres añadir más candidatos al prefiltro?"
            defaultMessage="¿Quieres añadir más candidatos al prefiltro?"
          />
        </StyledContent>
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent="space-between">
          <Grid item>
            <StyledNoButton
              color="primary"
              variant="contained"
              onClick={handleCancel}
              disabled={isExpanding}
            >
              <FormattedMessage
                id="ExpandPrefilterDialog.Cancelar"
                defaultMessage="Cancelar"
              />
            </StyledNoButton>
          </Grid>
          <Grid item>
            <StyledYesButton
              color="primary"
              variant="contained"
              onClick={handleConfirm}
              disabled={isExpanding}
            >
              {isExpanding ? (
                <CircularProgress size={20} thickness={5} disableShrink />
              ) : (
                <FormattedMessage
                  id="ExpandPrefilterDialog.Sí, añadir"
                  defaultMessage="Sí, añadir"
                />
              )}
            </StyledYesButton>
          </Grid>
        </Grid>
      </DialogActions>
    </StyledExpandPrefilterDialog>
  );
};

export default ExpandPrefilterDialog;
